import { useEffect, useState } from "react";
import { _getUserGroups, _getUser, _saveUserDisplayName } from "../data/users";
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../utils/firebase';
import RequestMyData from "./partial/RequestMyData";
import DeleteMyData from "./partial/DeleteMyData";
import { useNavigate } from "react-router-dom";

function ManageAccount() {
    const [isLoading, setIsLoading] = useState(true);

    const navigate = useNavigate();
    useEffect(() => {
        // onAuthStateChanged returns an unsubscribe function
        const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
            if (auth) {
                setIsLoading(false);
            }
        });

        // Clean up the listener when the component unmounts
        return () => unsubscribe();
    }, []);


    if (isLoading) {
        return (<></>);
    }

    return (
        <>

            <div className="container indent-from-top ml-2 mr-2">

                <header className="has-text-centered mb-4">
                    <p className="subtitle">Account Management</p>
                </header>

                <span>{auth.currentUser.metadata.providerId}</span>
                {auth.currentUser.providerData != null && auth.currentUser.providerData.length >= 1 && auth.currentUser.providerData[0].providerId === "password" &&
                    <>
                        <div className="subtitle has-text-weight-bold is-clickable" onClick={() => { navigate("/changePassword") }}>
                            Change Password &gt;
                        </div>
                        <hr />
                    </>
                }

                <RequestMyData />

                <DeleteMyData />

            </div>
        </>
    )
}

export default ManageAccount; 